export const buildUniqueName = (name: string, currentViewNames: string[]) => {
  let newName = name;
  let counter = 1;
  while (currentViewNames.indexOf(newName) !== -1) {
    newName = `${name} (${counter++})`;
  }
  return newName;
};

export const nameDuplicate = (originLabel: string, currentViewLabels: string[]): string => {
  let baseLabel = originLabel;

  const copyRegex = /(.*?)(?: Copy \(\d+\))?$/;
  const match = originLabel.match(copyRegex);
  if (match) {
    baseLabel = match[1].trim();
  }

  const regex = new RegExp(`^${baseLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')} Copy \\((\\d+)\\)$`);

  let maxNumber = 0;
  for (const label of currentViewLabels) {
    const m = label.match(regex);
    if (m) {
      const num = parseInt(m[1], 10);
      if (num > maxNumber) {
        maxNumber = num;
      }
    }
  }

  return `${baseLabel} Copy (${maxNumber + 1})`;
};
